import Accreditations from '../containers/clients/components/accreditations/accreditationList/reducer';
import AccreditationsListSettings from '../containers/admin/accreditations/accreditationsList/reducer';
import AccreditationsSettings from '../containers/admin/accreditations/accreditation/reducer';
import AccreditationsSettingsLogs from '../containers/admin/accreditations/accreditation/logs/reducer';
import ActiveJobs from '../containers/jobs/activeJobList/reducer';
import AddAccreditation from '../containers/clients/components/accreditations/accreditation/addAccreditation/reducer';
import AddApplicantToMyTeam from '../containers/clients/units/unit/myTeam/addApplicantModal/reducer';
import AddNewPriceList from '../containers/clients/units/unit/priceList/addNewPriceList/reducer';
import AddNewPriceListBulkMarkup from '../containers/clients/units/unit/priceList/addNewPriceList/addBulkMarkupModal/reducer';
import AddNewPriceListImportFile from '../containers/clients/units/unit/priceList/addNewPriceList/importFileModal/reducer';
import AddNewSkillModal from '../containers/talent/talent/skills/addSkillModal/reducer';
import AdminAlgorithm from '../containers/admin/algorithm/reducer';
import AdminEditUnmatchedOption from '../containers/admin/editUnmatchedOption/reducer';
import AdminOrganization from '../containers/admin/organization/reducer';
import AdminReferrals from '../containers/admin/referrals/reducer';
import AgenciesActiveList from '../containers/agencies/activeList/reducer';
import AgenciesInviteList from '../containers/agencies/inviteList/reducer';
import AgenciesRemovedList from '../containers/agencies/removedList/reducer';
import AgencyCancellationPolicy from '../containers/agencies/viewAgency/cancellationPolicy/reducer';
import AgencyContractsV2Editor from '../containers/agencies/agencyContractsV2/editAgencyContract/reducer';
import AgencyContractsV2Mutations from '../containers/agencies/agencyContractsV2/mutations/reducer';
import AgencyContractsV2Pickers from '../containers/agencies/agencyContractsV2/pickers/reducer';
import AgencyContractsV2RateLines from '../containers/agencies/agencyContractsV2/viewAgencyContract/rateLines/reducer';
import AgencyContractsV2View from '../containers/agencies/agencyContractsV2/viewAgencyContract/reducer';
import AgencyCreateEdit from '../containers/agencies/editAgency/reducer';
import AgencyView from '../containers/agencies/viewAgency/reducer';
import AgencyViewComments from '../containers/agencies/viewAgency/comments/reducer';
import AgencyViewLogs from '../containers/agencies/viewAgency/logs/reducer';
import AgencyViewUsers from '../containers/agencies/viewAgency/users/reducer';
import AgencyWorkersList from '../containers/agencyWorkers/agencyWorkersList/reducer';
import App from './app/reducer';
import AppBootstrap from './appBootstrap/reducer';
import AppUserBootstrap from './appUserBootstrap/reducer';
import Applicant from '../containers/applicants/applicant/reducer';
import ApplicantAccreditation from '../containers/applicants/applicant/accreditations/accreditation/reducer';
import ApplicantAccreditations from '../containers/applicants/applicant/accreditations/accreditationsList/reducer';
import ApplicantAssessments from '../containers/applicants/applicant/assessments/reducer';
import ApplicantComments from '../containers/applicants/applicant/comments/reducer';
import ApplicantExperiences from '../containers/applicants/applicant/experiences/experiencesList/reducer';
import ApplicantInterviewDetails from '../containers/applicants/applicant/interviewDetails/reducer';
import ApplicantLogs from '../containers/applicants/applicant/logs/reducer';
import ApplicantReferrals from '../containers/applicants/applicant/referrals/referralsList/reducer';
import ApplicantSessions from '../containers/applicants/applicant/sessions/reducer';
import ApplicantSuperannuations from '../containers/applicants/applicant/superannuations/reducer';
import Applicants from '../containers/applicants/applicantList/reducer';
import AssignMultidayWorker from '../containers/jobs/job/bookings/booking/assignMultidayWorker/reducer';
import AssignTalent from '../containers/jobs/job/bookings/booking/assign/reducer';
import AttentionRequiredInvoices from '../containers/agencies/invoiceList/attentionRequired/reducer';
import AttentionRequiredList from '../containers/jobs/attentionRequiredList/reducer';
import Attire from '../containers/admin/attires/attire/reducer';
import Attires from '../containers/admin/attires/attireList/reducer';
import Auth from './auth/reducer';
import AutomationConfig from '../containers/admin/automationConfig/reducer';
import BlockedTalents from '../containers/clients/units/unit/blockedTalents/reducer';
import Booking from '../containers/jobs/job/bookings/booking/reducer';
import BulkEditCheckinCheckout from '../containers/jobs/job/bookings/booking/bulkEditCheckinCheckout/reducer';
import BulkUploadWorkers from '../containers/talent/talentList/bulkUploadWorkers/reducer';
import CalendarView from '../containers/jobs/calendarView/reducer';
import ChangeToWorking from '../containers/jobs/job/bookings/booking/changeToWorking/reducer';
import Checklists from '../containers/admin/checklists/reducer';
import Client from '../containers/clients/units/unit/reducer';
import ClientComments from '../containers/clients/units/unit/comments/reducer';
import ClientFeedbackOptions from '../containers/admin/clientFeedbackOptions/reducer';
import ClientLogs from '../containers/clients/units/unit/logs/reducer';
import Clients from '../containers/clients/units/unitList/reducer';
import Companies from '../containers/clients/companies/companyList/reducer';
import Company from '../containers/clients/companies/company/reducer';
import CompanyComments from '../containers/clients/companies/company/comments/reducer';
import CompanyDivisionsGrid from '../containers/clients/companies/company/divisionsGrid/reducer';
import CompanyLogs from '../containers/clients/companies/company/logs/reducer';
import CompanyUnitsGrid from '../containers/clients/companies/company/unitsGrid/reducer';
import ContractSpecificAgreements from '../containers/clients/companies/company/contractSpecificAgreements/reducer';
import ConvertToPermanent from '../containers/agencyWorkers/convertToPermanent/reducer';
import CopyForBrand from '../containers/admin/districts/districtList/brandCopyModal/reducer';
import CountriesSettings from './countriesSettings/reducer';
import CreateLegalEntity from '../containers/admin/legalEntities/createLegalEntity/reducer';
import DataTable from '../components/dataTable/reducer';
import DataUploads from '../containers/settings/dataUploads/reducer';
import DemoUser from '../containers/admin/demoUsers/demoUser/reducer';
import DemoUsers from '../containers/admin/demoUsers/demoUsersList/reducer';
import DeniedTalents from '../containers/admin/deniedTalent/deniedTalentList/reducer';
import DenyApplicantModal from '../containers/applicants/applicant/denyApplicantModal/reducer';
import District from '../containers/admin/districts/district/reducer';
import DistrictLogs from '../containers/admin/districts/district/viewDistrict/districtLogs/reducer';
import Districts from '../containers/admin/districts/districtList/reducer';
import Division from '../containers/clients/divisions/division/reducer';
import DivisionComments from '../containers/clients/divisions/division/comments/reducer';
import DivisionLogs from '../containers/clients/divisions/division/logs/reducer';
import DivisionUnitsGrid from '../containers/clients/divisions/division/unitsGrid/reducer';
import Divisions from '../containers/clients/divisions/divisionList/reducer';
import EditAccreditation from '../containers/clients/components/accreditations/accreditation/editAccreditation/reducer';
import EditBackups from '../containers/jobs/job/bookings/booking/editBackups/reducer';
import EditBooking from '../containers/jobs/job/bookings/booking/editBooking/reducer';
import EditRateEngine from '../containers/admin/pricing/rateEngine/editRateEngine/reducer';
import EditShift from '../containers/jobs/job/bookings/booking/editShift/reducer';
import EnableSkillModal from '../containers/talent/talent/skills/enableSkillModal/reducer';
import FeatureFlags from './featureFlags/reducer';
import FlexAppOptions from '../containers/admin/flexAppOptions/reducer';
import FutureJobs from '../containers/jobs/futureJobList/reducer';
import GlobalSearch from '../containers/globalSearch/reducer';
import HolidayPricing from '../containers/admin/holidayPricing/reducer';
import HolidayPricingLogs from '../containers/admin/holidayPricing/logs/reducer';
import InfractionReportModal from '../containers/talent/talent/pastJobsList/jobsList/infractionReportModal/reducer';
import InfractionsExceptions from '../containers/landingPage/infractionsExceptions/reducer';
import InterviewPopup from '../containers/applicants/interviewPopup/reducer';
import Interviews from '../containers/applicants/interviewList/reducer';
import Invoice from '../containers/clients/units/unit/invoices/invoice/reducer';
import InvoiceJob from '../containers/clients/units/unit/invoices/invoice/invoiceJobsList/reducer';
import InvoiceList from '../containers/agencies/invoiceList/reducer';
import InvoiceNonActivatedJob from '../containers/clients/units/unit/invoices/invoice/invoiceNonActivatedJobsList/reducer';
import Invoices from '../containers/clients/units/unit/invoices/invoiceList/reducer';
import Job from '../containers/jobs/job/reducer';
import JobAddPromocode from '../containers/jobs/job/addPromocode/reducer';
import JobAttentionRequiredList from '../containers/jobs/job/attentionRequired/reducer';
import JobComments from '../containers/jobs/job/comments/reducer';
import JobLogs from '../containers/jobs/job/logs/reducer';
import JobManagers from '../containers/jobs/job/managers/reducer';
import JobMessages from '../containers/jobs/job/messages/reducer';
import JobOtherPayouts from '../containers/jobs/job/otherPayouts/reducer';
import JobTypesList from '../containers/admin/positions/jobTypes/reducer';
import JobTypesMutations from '../containers/admin/positions/jobTypes/mutations/reducer';
import JobsAtRisk from '../containers/landingPage/jobsAtRisk/reducer';
import LandingPage from '../containers/landingPage/reducer';
import LeaderBoardList from '../containers/landingPage/leaderBoard/reducer';
import Leads from '../containers/leads/leadList/reducer';
import LegalEntitiesList from '../containers/admin/legalEntities/legalEntitiesList/reducer';
import LegalEntitiesOptions from './legalEntitiesOptions/reducer';
import LoginWithSSO from '../containers/loginWithSSO/reducer';
import Manager from '../containers/clients/units/unit/managers/manager/reducer';
import Managers from '../containers/clients/units/unit/managers/managerList/reducer';
import Market from '../containers/admin/markets/market/reducer';
import Markets from '../containers/admin/markets/marketsList/reducer';
import MarketsDistricts from '../containers/admin/markets/market/disctrictsList/reducer';
import MetabaseSettings from './metabase/reducer';
import NewSkillApplications from '../containers/landingPage/newSkillsApplications/reducer';
import Notifications from './notifications/reducer';
import NotificationsCenter from '../containers/notificationsCenter/reducer';
import OnBehalfOf from '../containers/onBehalfOf/reducer';
import OrgCancellationPolicy from '../containers/admin/cancellationPolicy/reducer';
import OrgCancellationPolicyLogs from '../containers/admin/cancellationPolicy/logs/reducer';
import OrgSwitcher from './orgSwitcher/reducer';
import Organization from '../containers/organizations/organization/reducer';
import OrganizationsList from '../containers/organizations/organizationsList/reducer';
import Pants from '../containers/admin/attires/attire/attireGroups/pantsList/reducer';
import PantsDetail from '../containers/admin/attires/attire/attireGroups/pants/reducer';
import Partner from '../containers/admin/partners/partner/reducer';
import Partners from '../containers/admin/partners/partnerList/reducer';
import PastJobs from '../containers/jobs/pastJobList/reducer';
import PaymentHistory from '../containers/jobs/job/paymentHistory/reducer';
import PaymentMethodsAddCreditModal from '../containers/clients/units/unit/paymentMethods/tabs/credits/modal/reducer';
import PaymentMethodsCredits from '../containers/clients/units/unit/paymentMethods/tabs/credits/reducer';
import PaymentMethodsInvoices from '../containers/clients/units/unit/paymentMethods/tabs/invoices/reducer';
import Payroll from '../containers/admin/payroll/reducer';
import PendingSkillsModal from '../containers/talent/talent/skills/pendingSkillsModal/reducer';
import Permissions from './permissions/reducer';
import Pool from '../containers/jobs/job/bookings/booking/pools/reducer';
import PoolAgencies from '../containers/jobs/job/bookings/booking/pools/tabs/agencies/reducer';
import PoolsBreakdown from '../containers/landingPage/poolsBreakdown/reducer';
import Position from '../containers/admin/positions/position/reducer';
import PositionAccreditations from '../containers/admin/positions/position/accreditations/accreditationsList/reducer';
import PositionAvailability from '../containers/admin/pricing/positionAvailability/reducer';
import PositionLogs from '../containers/admin/positions/position/logs/logList/reducer';
import Positions from '../containers/admin/positions/positionList/reducer';
import PredictionsList from '../containers/landingPage/predictions/reducer';
import Profile from '../containers/profile/reducer';
import PromoCode from '../containers/admin/promoCodes/promoCode/reducer';
import PromoCodes from '../containers/admin/promoCodes/promoCodeList/reducer';
import RateCardCreate from '../containers/admin/pricing/rateCards/createRateCard/reducer';
import RateCardReview from '../containers/admin/pricing/rateCards/reviewRateCard/reducer';
import RateCardView from '../containers/admin/pricing/rateCards/viewRateCard/reducer';
import RateCards from '../containers/admin/pricing/rateCards/reducer';
import RateEngineFormData from '../containers/admin/pricing/rateEngine/rateEngineShared/formData/reducer';
import RateEngineList from '../containers/admin/pricing/rateEngine/rateEngineList/reducer';
import RateEngineListShort from '../containers/admin/pricing/rateEngine/rateEngineShared/listShort/reducer';
import RateEngineMutations from '../containers/admin/pricing/rateEngine/rateEngineShared/mutations/reducer';
import RateSimulator from '../containers/admin/pricing/rateSimulator/reducer';
import RemoveMultidayWorker from '../containers/jobs/job/bookings/booking/removeMultidayWorker/reducer';
import RequestStatus from './requestStatus/reducer';
import ResolveHours from '../containers/jobs/job/bookings/booking/resolveHours/reducer';
import ReviewTimings from '../containers/jobs/job/bookings/booking/reviewTimingsModal/reducer';
import Sector from '../containers/admin/sectors/sector/reducer';
import SectorLogs from '../containers/admin/sectors/sector/logList/reducer';
import Sectors from '../containers/admin/sectors/sectorList/reducer';
import Session from '../containers/orientations/sessions/session/reducer';
import SessionAdd from '../containers/orientations/addSession/reducer';
import SessionCalendar from '../containers/orientations/sessions/session/sections/sessionCalendar/reducer';
import SessionComments from '../containers/orientations/sessions/session/sections/sessionComments/commentList/reducer';
import SessionListActive from '../containers/orientations/sessions/sessionListActive/reducer';
import SessionListFuture from '../containers/orientations/sessions/sessionListFuture/reducer';
import SessionListPast from '../containers/orientations/sessions/sessionListPast/reducer';
import SessionLogs from '../containers/orientations/sessions/session/sections/sessionLogs/reducer';
import SessionManagers from '../containers/orientations/sessions/session/sections/sessionManagers/reducer';
import SessionRecruits from '../containers/orientations/sessions/session/sections/sessionRecruits/reducer';
import SessionTeamChat from '../containers/orientations/sessions/session/sections/sessionTeamChat/reducer';
import Settings from '../containers/settings/reducer';
import Shirt from '../containers/admin/attires/attire/attireGroups/shirt/reducer';
import Shirts from '../containers/admin/attires/attire/attireGroups/shirtList/reducer';
import Shoes from '../containers/admin/attires/attire/attireGroups/shoesList/reducer';
import ShoesDetail from '../containers/admin/attires/attire/attireGroups/shoes/reducer';
import SignIn from '../containers/signIn/email/reducer';
import Skills from '../containers/talent/talent/skills/reducer';
import SprintMa from '../containers/jobs/job/sprintMa/reducer';
import StartAppSettings from './startAppSettings/reducer';
import SubUnit from '../containers/clients/subUnits/subUnit/reducer';
import SubUnitBlockedTalents from '../containers/clients/subUnits/subUnit/blockedTalents/reducer';
import SubUnitComments from '../containers/clients/subUnits/subUnit/comments/reducer';
import SubUnitInvoice from '../containers/clients/subUnits/subUnit/invoices/invoice/reducer';
import SubUnitInvoiceJob from '../containers/clients/subUnits/subUnit/invoices/invoice/invoiceJobsList/reducer';
import SubUnitInvoiceNonActivatedJob from '../containers/clients/subUnits/subUnit/invoices/invoice/invoiceNonActivatedJobsList/reducer';
import SubUnitInvoices from '../containers/clients/subUnits/subUnit/invoices/invoiceList/reducer';
import SubUnitLogs from '../containers/clients/subUnits/subUnit/logs/reducer';
import SubUnitManager from '../containers/clients/subUnits/subUnit/managers/manager/reducer';
import SubUnitManagers from '../containers/clients/subUnits/subUnit/managers/managerList/reducer';
import SubUnitPriceList from '../containers/clients/subUnits/subUnit/priceList/reducer';
import SubUnitReferrals from '../containers/clients/subUnits/subUnit/referrals/reducer';
import SubUnits from '../containers/clients/subUnits/subUnitList/reducer';
import SubUnitsMyTeamList from '../containers/clients/subUnits/subUnit/myTeam/reducer';
import Talent from '../containers/talent/talent/reducer';
import TalentAccreditation from '../containers/talent/talent/accreditations/accreditation/reducer';
import TalentAccreditations from '../containers/talent/talent/accreditations/accreditationsList/reducer';
import TalentBackgroundChecks from '../containers/talent/talent/backgroundChecks/reducer';
import TalentBlockedUnits from '../containers/talent/talent/blockedUnits/reducer';
import TalentCareer from '../containers/talent/talent/career/reducer';
import TalentComments from '../containers/talent/talent/comments/reducer';
import TalentConversionRule from '../containers/clients/companies/company/talentConversionRule/reducer';
import TalentJobInvites from '../containers/talent/talent/jobInvites/reducer';
import TalentLogs from '../containers/talent/talent/logs/reducer';
import TalentPastJobsCalendarView from '../containers/talent/talent/pastJobsList/calendarView/reducer';
import TalentPastJobsList from '../containers/talent/talent/pastJobsList/jobsList/reducer';
import TalentReferrals from '../containers/talent/talent/referrals/referralsList/reducer';
import TalentSuperannuations from '../containers/talent/talent/superannuations/reducer';
import TalentSuspension from '../containers/talent/talent/suspension/reducer';
import TalentWarningAndSuspensions from '../containers/talent/talent/warningAndSuspensions/reducer';
import Talents from '../containers/talent/talentList/reducer';
import TerminatedTalents from '../containers/admin/terminatedTalent/terminatedTalentList/reducer';
import TermsPrivacy from '../containers/admin/terms&privacy/reducer';
import TimeSheetsList from '../containers/jobs/timesheetsList/reducer';
import TransferAssociate from '../containers/applicants/applicant/transferAssociate/reducer';
import TrustedTalentApplicant from '../containers/applicants/applicant/trustedTalentApplicantModal/reducer';
import UnclosedJobs from '../containers/landingPage/unclosedJobs/reducer';
import UndoNCNSForm from '../containers/jobs/job/bookings/booking/undoNCNSForm/reducer';
import UnitAgencies from '../containers/clients/units/unit/agencies/reducer';
import UnitEditAgencies from '../containers/clients/units/unit/agencies/editAgencies/reducer';
import UnitEditPaymentMethods from '../containers/clients/units/unit/paymentMethods/details/reducer';
import UnitEditPaymentMethodsAddBankAccount from '../containers/clients/units/unit/paymentMethods/details/detailsComponents/bankAccounts/modal/reducer';
import UnitEditPaymentMethodsAddCreditCard from '../containers/clients/units/unit/paymentMethods/details/detailsComponents/creditCards/modal/reducer';
import UnitEditPaymentMethodsCreditCards from '../containers/clients/units/unit/paymentMethods/details/detailsComponents/creditCards/reducer';
import UnitPaymentMethodsBankAccounts from '../containers/clients/units/unit/paymentMethods/tabs/bankAccounts/reducer';
import UnitPaymentMethodsCards from '../containers/clients/units/unit/paymentMethods/tabs/cards/reducer';
import UnitPriceList from '../containers/clients/units/unit/priceList/reducer';
import UnitReferrals from '../containers/clients/units/unit/referrals/reducer';
import UnitSubUnitsGrid from '../containers/clients/units/unit/subUnitsGrid/reducer';
import UnitsMyTeamList from '../containers/clients/units/unit/myTeam/reducer';
import UnmatchOptions from '../containers/admin/unmatchOptions/reducer';
import UnmatchedTrends from '../containers/landingPage/unmatchedTrends/reducer';
import UpdateAgencyContract from '../containers/agencies/updateAgencyContract/reducer';
import UpdateRatings from '../containers/jobs/job/bookings/booking/updateRatings/reducer';
import User from '../containers/admin/users/user/reducer';
import UserGuide from '../containers/userGuide/reducer';
import UserLogs from '../containers/admin/users/user/logList/reducer';
import UserProfile from './userProfile/reducer';
import Users from '../containers/admin/users/userList/reducer';
import ValidateSession from './validateSession/reducer';
import ViewAgencyWorker from '../containers/agencyWorkers/viewAgencyWorker/reducer';
import ViewRateEngine from '../containers/admin/pricing/rateEngine/viewRateEngine/reducer';
import ViewSkillModal from '../containers/talent/talent/skills/viewSkillModal/reducer';
import YourApplicants from '../containers/landingPage/yourApplicants/reducer';

const reducers = {
  Accreditations,
  AccreditationsListSettings,
  AccreditationsSettings,
  AccreditationsSettingsLogs,
  ActiveJobs,
  AddAccreditation,
  AddApplicantToMyTeam,
  AddNewPriceList,
  AddNewPriceListBulkMarkup,
  AddNewPriceListImportFile,
  AddNewSkillModal,
  AdminAlgorithm,
  AdminEditUnmatchedOption,
  AdminOrganization,
  AdminReferrals,
  AgenciesActiveList,
  AgenciesInviteList,
  AgenciesRemovedList,
  AgencyCancellationPolicy,
  AgencyContractsV2Editor,
  AgencyContractsV2Mutations,
  AgencyContractsV2Pickers,
  AgencyContractsV2RateLines,
  AgencyContractsV2View,
  AgencyCreateEdit,
  AgencyView,
  AgencyViewComments,
  AgencyViewLogs,
  AgencyViewUsers,
  AgencyWorkersList,
  App,
  AppBootstrap,
  AppUserBootstrap,
  Applicant,
  ApplicantAccreditation,
  ApplicantAccreditations,
  ApplicantAssessments,
  ApplicantComments,
  ApplicantExperiences,
  ApplicantInterviewDetails,
  ApplicantLogs,
  ApplicantReferrals,
  ApplicantSessions,
  ApplicantSuperannuations,
  Applicants,
  AssignMultidayWorker,
  AssignTalent,
  AttentionRequiredInvoices,
  AttentionRequiredList,
  Attire,
  Attires,
  Auth,
  AutomationConfig,
  BlockedTalents,
  Booking: Booking(),
  BulkEditCheckinCheckout,
  BulkUploadWorkers,
  CalendarView,
  ChangeToWorking,
  Checklists,
  Client,
  ClientComments,
  ClientFeedbackOptions,
  ClientLogs,
  Clients,
  Companies,
  Company,
  CompanyComments,
  CompanyDivisionsGrid,
  CompanyLogs,
  CompanyUnitsGrid,
  ContractSpecificAgreements,
  ConvertToPermanent,
  CopyForBrand,
  CountriesSettings,
  CreateLegalEntity,
  DataTable,
  DataUploads,
  DemoUser,
  DemoUsers,
  DeniedTalents,
  DenyApplicantModal,
  District,
  DistrictLogs,
  Districts,
  Division,
  DivisionComments,
  DivisionLogs,
  DivisionUnitsGrid,
  Divisions,
  EditAccreditation,
  EditBackups,
  EditBooking,
  EditRateEngine,
  EditShift,
  EnableSkillModal,
  FeatureFlags,
  FlexAppOptions,
  FutureJobs,
  GlobalSearch,
  HolidayPricing,
  HolidayPricingLogs,
  InfractionReportModal,
  InfractionsExceptions,
  InterviewPopup,
  Interviews,
  Invoice,
  InvoiceJob,
  InvoiceList,
  InvoiceNonActivatedJob,
  Invoices,
  Job,
  JobAddPromocode,
  JobAttentionRequiredList,
  JobComments,
  JobLogs,
  JobManagers,
  JobMessages,
  JobOtherPayouts,
  JobTypesList,
  JobTypesMutations,
  JobsAtRisk,
  LandingPage,
  LeaderBoardList,
  Leads,
  LegalEntitiesList,
  LegalEntitiesOptions,
  LoginWithSSO,
  Manager,
  Managers,
  Market,
  Markets,
  MarketsDistricts,
  MetabaseSettings,
  NewSkillApplications,
  Notifications,
  NotificationsCenter,
  OnBehalfOf,
  OrgCancellationPolicy,
  OrgCancellationPolicyLogs,
  OrgSwitcher,
  Organization,
  OrganizationsList,
  Pants,
  PantsDetail,
  Partner,
  Partners,
  PastJobs,
  PaymentHistory,
  PaymentMethodsAddCreditModal,
  PaymentMethodsCredits,
  PaymentMethodsInvoices,
  Payroll,
  PendingSkillsModal,
  Permissions,
  Pool,
  PoolAgencies,
  PoolsBreakdown,
  Position,
  PositionAccreditations,
  PositionAvailability,
  PositionLogs,
  Positions,
  PredictionsList,
  Profile,
  PromoCode,
  PromoCodes,
  RateCardCreate,
  RateCardReview,
  RateCardView,
  RateCards,
  RateEngineFormData,
  RateEngineList,
  RateEngineListShort,
  RateEngineMutations,
  RateSimulator,
  RemoveMultidayWorker,
  RequestStatus,
  ResolveHours,
  ReviewTimings,
  Sector,
  SectorLogs,
  Sectors,
  Session,
  SessionAdd,
  SessionCalendar,
  SessionComments,
  SessionListActive,
  SessionListFuture,
  SessionListPast,
  SessionLogs,
  SessionManagers,
  SessionRecruits,
  SessionTeamChat,
  Settings,
  Shirt,
  Shirts,
  Shoes,
  ShoesDetail,
  SignIn,
  Skills,
  SprintMa,
  StartAppSettings,
  SubUnit,
  SubUnitBlockedTalents,
  SubUnitComments,
  SubUnitInvoice,
  SubUnitInvoiceJob,
  SubUnitInvoiceNonActivatedJob,
  SubUnitInvoices,
  SubUnitLogs,
  SubUnitManager,
  SubUnitManagers,
  SubUnitPriceList,
  SubUnitReferrals,
  SubUnits,
  SubUnitsMyTeamList,
  Talent,
  TalentAccreditation,
  TalentAccreditations,
  TalentBackgroundChecks,
  TalentBlockedUnits,
  TalentCareer,
  TalentComments,
  TalentConversionRule,
  TalentJobInvites,
  TalentLogs,
  TalentPastJobsCalendarView,
  TalentPastJobsList,
  TalentReferrals,
  TalentSuperannuations,
  TalentSuspension,
  TalentWarningAndSuspensions,
  Talents,
  TerminatedTalents,
  TermsPrivacy,
  TimeSheetsList,
  TransferAssociate,
  TrustedTalentApplicant,
  UnclosedJobs,
  UndoNCNSForm,
  UnitAgencies,
  UnitEditAgencies,
  UnitEditPaymentMethods,
  UnitEditPaymentMethodsAddBankAccount,
  UnitEditPaymentMethodsAddCreditCard,
  UnitEditPaymentMethodsCreditCards,
  UnitPaymentMethodsBankAccounts,
  UnitPaymentMethodsCards,
  UnitPriceList,
  UnitReferrals,
  UnitSubUnitsGrid,
  UnitsMyTeamList,
  UnmatchOptions,
  UnmatchedTrends,
  UpdateAgencyContract,
  UpdateRatings,
  User,
  UserGuide,
  UserLogs,
  UserProfile,
  Users,
  ValidateSession,
  ViewAgencyWorker,
  ViewRateEngine,
  ViewSkillModal,
  YourApplicants,
};

export default reducers;
